<img class="brand__logo brand__logo__new" [src]="logoFile$ | async" alt="" />

<h2 class="page-head">{{currentModuleDescription$ | async}}</h2>

<div class="dumbDropDownWrapper">
  <div class="dumbDropDown">
    <span>Module</span>

    <mat-select [multiple]="false" [value]="currentModulePath$ | async">
      <ng-container *ngFor="let item of modules$ | async">
        <mat-option *ngIf="rolesOk(item.needsRole) | async" [value]="item.path" [routerLink]="['/',item.path]">
          {{item.description}}</mat-option>
      </ng-container>
    </mat-select>

  </div>
</div>

<app-nav-user-buttons [username]="userDisplayName$ | async"></app-nav-user-buttons>
